import { useMemo, useState } from 'react';
import { invariant } from '../../utils/commonUtils';
import { AvailableContext } from './use-available-contexts';
import { InputContext } from './use-input-context';

export function useSelectedContext(availableContexts: AvailableContext[], inputContext: InputContext) {
  const [selectedContextId, setSelectedContextId] = useState(() =>
    getInitialContextId(availableContexts, inputContext),
  );

  const selectedContext = useMemo(() => {
    const context = availableContexts.find((ctx) => ctx.isActive(selectedContextId));
    invariant(context !== undefined, `No context found for id: ${selectedContextId}`);
    return context;
  }, [availableContexts, selectedContextId]);

  return {
    selectedContext,
    selectedContextId,
    setSelectedContextId,
  };
}

function getInitialContextId(availableContexts: AvailableContext[], inputContext: InputContext) {
  const firstContext = availableContexts[0];

  const context = availableContexts.find((ctx) => {
    if (inputContext.platformTitleId !== undefined) {
      return ctx.hasPlatformTitleId(inputContext.platformTitleId);
    }

    if (inputContext.orderByProviderId !== undefined) {
      return ctx.hasProviderId(inputContext.orderByProviderId);
    }

    if (inputContext.orderByServiceType !== undefined) {
      return ctx.hasServiceType(inputContext.orderByServiceType);
    }

    return ctx.isActive(firstContext.id);
  });

  return context?.id || firstContext.id;
}
